import LZString from 'lz-string';
import jsonpack from 'jsonpack';
import { PageViewStack } from '../redux/reducers/pageViewsReducer';

export const encodeState = (state: PageViewStack): string => {
  const packed = jsonpack.pack(state, {
    verbose: false,
  });
  return LZString.compressToEncodedURIComponent(packed);
};

export const decodeState = <T>(encoded: string): T | null => {
  try {
    const decompressed = LZString.decompressFromEncodedURIComponent(encoded);
    if (!decompressed) return null;

    return jsonpack.unpack(decompressed) as T;
  } catch {
    return null;
  }
};

export const hasValidTitles = (stack: PageViewStack) =>
  stack.every((view) =>
    Object.values(view.breadcrumbs || {}).every((area) =>
      area.every((crumb) => Boolean(crumb?.title)),
    ),
  );
